export default "https://cdn-static.gokick.com/assets/713f881f9452b025a6ed3fcaec249d98fea8bb41/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";